import { UI } from 'common';
import escape from 'lodash/escape';
import isArray from 'lodash/isArray';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

const { Steppers } = UI;

// build location text
const buildLocationText = ({ city, countryCode, postalCode, stateProvince }) =>
	[
		city ? `${city},` : '',
		stateProvince || '',
		countryCode === 'US' ? postalCode : countryCode,
	]
		.filter(str => str)
		.join(' ');

// build mockup for event content
const buildContentMockup = (title, time, address) =>
	[
		'<p class="title">',
		escape(title),
		'</p>',
		`<p class="delivery-info-line">${escape(moment(time).format('LLL'))}</p>`,
		`<p class="delivery-info-line">${escape(buildLocationText(address))}</p>`,
	].join('');

const TrackingSteppers = ({ className, trackingEvents }) => {
	const steps = isArray(trackingEvents)
		? trackingEvents.reduce((_steps, trackingEvent, idx) => {
				const {
					eventDescription,
					occuredAt,
					city,
					countryCode,
					stateProvince,
					postalCode,
				} = trackingEvent;

				_steps.push({
					message: buildContentMockup(eventDescription, occuredAt, {
						city,
						countryCode,
						stateProvince,
						postalCode,
					}),

					// to find out if it's the last event, verify the first event
					// if `event_description` field returns 'Delivered' string
					lastStep: idx === 0 && eventDescription === 'Delivered',
					firstStep: idx === trackingEvents.length - 1,
				});

				return _steps;
			}, [])
		: [];

	return (
		<div className={`history-tracking-steppers ${className}`}>
			<Steppers steps={steps} circleSize={16} circleAndTextSpace={30} />
		</div>
	);
};

TrackingSteppers.propTypes = {
	trackingEvents: PropTypes.array,
};

export default TrackingSteppers;
